export default __webpack_public_path__ + "static/amundsen-06852335bf9b58c27982f481015fbab4.png";